export const OPACITY_0 = 'opacity-0';
export const OPACITY_100 = 'opacity-100';
export const VISIBLE = 'visible';
export const INVISIBLE = 'invisible';
export const HIDDEN = 'hidden';
export const IS_OPEN_LG = 'lg:is-open';
export const IS_CLOSED_LG = 'lg:is-closed';
export const BORDER_GRAY = 'border-gray-500';
export const BORDER_ERROR = 'border-red-500';
export const BORDER_PRIMARY = 'border-blue-500';
export const BORDER_FOCUS = 'shadow-inner-border-sage';
export const BG_WHITE = 'bg-white';
export const BG_SELECTED = 'bg-gray-50';
export const BG_PRIMARY = 'bg-blue-500';
export const BG_ERROR = 'bg-red-50';
export const FONT_EMPHASIS = 'font-bold';
export const TEXT_INVERTED = 'text-white';
export const TEXT_PRIMARY = 'text-blue-500';
export const ROTATE_180 = 'rot-180';
export const OVERFLOW_HIDDEN = 'overflow-hidden';
export const OVERFLOW_AUTO_LG = 'lg:overflow-auto';
export const SCROLLING_TOUCH_LG = 'lg:scrolling-touch';
export const TRANSLATE_NEG_Y_FULL = '-translate-y-full';
export const TRANSLATE_Y_FULL = 'translate-y-full';
export const TRANSLATE_Y_0 = 'translate-y-0';
